import { BLOCKS, Document, INLINES } from '@contentful/rich-text-types'

export const internationalLogInUser: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value: 'Please send your cart to customer service.',
          data: {},
        },
      ],
      data: {},
    },
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value:
            'Ahead of processing your order, we will provide a formal quote including estimated lead time, freight, and any applicable taxes for your review.',
          data: {},
        },
      ],
      data: {},
    },
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value:
            'Payment is due in full a the time the order is confirmed. We accept credit card, wire and ACH as payment methods.',
          data: {},
        },
      ],
      data: {},
    },
  ],
}

export const internationalGuestUser: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value: 'Please log in or create an account to send your cart to a customer service specialist.',
          data: {},
        },
      ],
      data: {},
    },
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value:
            'Ahead of processing your order, we will provide a formal quote including estimated lead time, freight, and any applicable taxes for your review.',
          data: {},
        },
      ],
      data: {},
    },
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value:
            'Payment is due in full a the time the order is confirmed. We accept credit card, wire and ACH as payment methods.',
          data: {},
        },
      ],
      data: {},
    },
  ],
}

export const notLoggedInModalDocument: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: INLINES.HYPERLINK,
          content: [
            {
              nodeType: 'text',
              value: 'Sign in',
              marks: [],
              data: {},
            },
          ],
          data: {
            uri: '/login',
          },
        },
        {
          nodeType: 'text',
          marks: [],
          value: ' if you have an account with Curran. Otherwise, create an account or continue as a guest.',
          data: {},
        },
      ],
      data: {},
    },
  ],
}
